// extracted by mini-css-extract-plugin
export var option = "_4q-1";
export var optionActive = "_4q-2";
export var pill = "_4q-0";